$(function () {
    const updateSlide = function (swiper, mapping) {
        const imgMapped = mapping.find(function (i, index) {
            return index === swiper.realIndex;
        });
        imgMapped.img.siblings().removeClass('active');
        imgMapped.img.addClass('active');
    };

    $('[data-film-strip').each(function () {
        const $this = $(this);
        const $targetImg = $this.find($this.data('img-container'));
        const container = $(this).find('.swiper')[0];
        // load all the images
        const imgMapper = [];
        $this.find('[data-img]').each(function (index) {
            var $imgSlide = $(this);
            var $img = $imgSlide.find('> img');
            var img = $imgSlide.data('img');
            var title = $img.attr('title');
            $imgSlide.css({ 'background-image': "url('" + $img.attr('src') + "')" });

            imgMapper.push({
                img: $('<div class="img" style="background-image: url(\'' + img + '\');"><img src="' + img + '" title="' + title + '" /></div>').appendTo($targetImg),
                index
            });
        });
        $this.addClass('loaded');
        var swiper = new Swiper(container, {
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true
        }).on('slideChange', function () {
            updateSlide(this, imgMapper);
        }).on('click', function (swiper) {
            swiper.slideTo(swiper.clickedIndex);
        });
        $this.find('.swiper-controls .btn').on('click', function (ev) {
            ev.preventDefault();
            if ($(this).data('carousel-move') === 'prev') {
                swiper.slidePrev();
            } else {
                swiper.slideNext();
            }
        });
        updateSlide(swiper, imgMapper);
    });
});